import { RESET_EXTERNAL_SOURCE_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default () => actions[RESET_EXTERNAL_SOURCE_FORM]();
